<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t('viewAnalytics.summary.title') }}

    </h3>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';

export default {
  name: "Summary",
  created() {

  },
  watch: {

  },
  computed: {

  },
  methods: {

  }
}
</script>

<style scoped>

</style>